export default __webpack_public_path__ + "static/media/saml.0e745c88.png";